import { Button, Icon, Input } from "@deligoo/ui"
import clsx from "clsx"
import { LatLngTuple } from "leaflet"
import { useEffect, useState } from "react"
import { shallowEqual } from "react-redux"

import { useAppDispatch, useAppSelector } from "@/App"
import { setMapSearchVisibility, setPinnedLocation } from "@/store/ui"

import { DEFAULT_MAP_CENTER } from "../MainMap"
import { fetchLocationsFromHere, getLocationLabels, HereLocation } from "./HereLocation"
import cls from "./MapSearch.module.scss"

export const MapSearch = () => {
  const isOpen = useAppSelector((state) => state.ui.isMapSearchOpen)
  const cityBounds = useAppSelector((state) => state.teams.cityBounds)
  const pinnedLocation = useAppSelector((state) => state.ui.pinnedLocation, shallowEqual)
  const isAboutPanelVisible = useAppSelector((state) => !!state.ui.aboutPanel, shallowEqual)

  const dispatch = useAppDispatch()

  const [searchValue, setSearchValue] = useState("")
  const [locations, setLocations] = useState<HereLocation[] | null>(null)

  function toggleMapSearchVisibility() {
    dispatch(setMapSearchVisibility(!isOpen))
  }

  const mapCenter: LatLngTuple = cityBounds
    ? [cityBounds.getCenter().lat, cityBounds.getCenter().lng]
    : DEFAULT_MAP_CENTER

  async function fetchLocations() {
    const locations = await fetchLocationsFromHere(searchValue, mapCenter)
    setLocations(locations)
  }

  useEffect(() => {
    if (!isOpen) {
      setSearchValue("")
      setLocations(null)
      dispatch(setPinnedLocation(null))
    }
  }, [isOpen, dispatch])

  return (
    <div className={clsx(cls.mapSearchWrapper, isAboutPanelVisible && "mb-3")}>
      <Button variation="text" className={clsx(cls.toggler, isOpen && cls.open)} onClick={toggleMapSearchVisibility}>
        <Icon className={cls.togglerIcon} name={isOpen ? "close" : "search"} color="primary" />
      </Button>

      {isOpen && (
        <div className={cls.mapSearch}>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              fetchLocations()
            }}
            className={cls.searchBar}
          >
            <Input
              autoFocus
              type="search"
              placeholder="Wyszukaj adres"
              className={cls.input}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.currentTarget.value)
                if (pinnedLocation) dispatch(setPinnedLocation(null))
              }}
            />
            <Button
              color={searchValue.length > 0 ? "primary" : "muted"}
              variation="contrast"
              iconProps={{ name: "search" }}
              type="submit"
            />
          </form>

          <div className={cls.results}>
            {(!locations || locations?.length === 0) && (
              <div className={cls.empty}>
                <Icon name="list-1" size="extra-large" className={cls.emptyIcon} />
                {locations?.length === 0 && "Brak wyników"}
              </div>
            )}

            {locations?.map((location) => {
              const [label, sublabel] = getLocationLabels(location)
              const isPinned = location.id === pinnedLocation?.id

              return (
                <div
                  key={location.id}
                  className={clsx(cls.item, isPinned && cls.pinned)}
                  onClick={() => dispatch(setPinnedLocation(location))}
                >
                  <div className={cls.iconWrapper}>
                    <Icon name="location" color="primary" />
                  </div>
                  <div className={cls.labels}>
                    <div>{label}</div>
                    <div className={cls.sublabel}>{sublabel}</div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
